module.exports = __webpack_public_path__ + "static/media/aboutar.2146c9f7.png";